import {
  AfterViewInit,
  Component,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import * as React from "react";
import * as ReactDOM from "react-dom";
import ResetPassword from "./ResetPassword";

@Component({
  selector: "app-reset-password",
  template: `<div [id]="rootId" style="transition: 0.6s"></div>`,
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordWrapper implements OnChanges, OnDestroy, AfterViewInit {
  public rootId = "reset-password-root";

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngAfterViewInit(): void {
    this.render();
  }

  ngOnDestroy(): void {
    ReactDOM.unmountComponentAtNode(document.getElementById(this.rootId) as Element);
  }

  private render(): void {
    ReactDOM.render(
      React.createElement(ResetPassword),
      document.getElementById(this.rootId)
    );
  }
}
